import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { employeeStateSelector } from '~/selectors';

import { EmployeeLoginData } from './types';

export const useEmployeeLoginData = (): {
  employeeAdminLoginData: EmployeeLoginData;
  loginDataLoading: boolean;
  loginDataFailedLoading: boolean;
  hasLoginData: boolean;
} => {
  return useSelector((state: StoreState) => {
    return employeeStateSelector(state);
  });
};
